export enum FishingEventType {
  Catch = 'catch',
  Release = 'release',
}

export interface FishingSaleEvent {
  id: string
  type: FishingEventType
  catchId: string
  catchOccurredAt: string
  occurredAt: string
  amount: number
  currency: 'RUB'
}
